module.exports = __webpack_public_path__ + "img/voltar.781c6fb4.svg";